import React from 'react';

const AdminTaskTest = () => {
  return (
    <div style={{ padding: '20px' }}>
      <h1>AdminTask Test Page</h1>
      <p>If you can see this, the routing is working!</p>
      <p>Current time: {new Date().toLocaleString()}</p>
    </div>
  );
};

export default AdminTaskTest;